import { useNavigate } from 'react-router-dom'

interface SkillCardProps {
  name: string
  image: string
  id: string
  type?: 'SMALL' | 'BIG'
  description?: string
}

export const SkillCard = ({ name, image, type = 'SMALL', description, id }: SkillCardProps) => {
  const smallCardClasses = {
    outerCard: 'w-[211px] h-[194px]',
    innerCard: 'w-[207px]',
    imageContainer: 'w-[207px] h-[120px]',
    imageSize: 'size-[96px]',
    nameText: 'pt-3 pl-[10px] pr-[6px] pb-4 body-s h-[66px] line-clamp-2 break-word text-ellipsis',
  }
  const bigCardClasses = {
    outerCard: 'w-[358px] h-[416px]',
    innerCard: 'w-[354px]',
    imageContainer: 'w-[354px] h-[208px]',
    imageSize: 'size-[162px]',
    nameText: 'p-4 pb-2 strong-m',
  }

  // Determine description height based on name length
  const getDescriptionHeight = (): string => {
    return name.length > 30 ? 'h-[120px]' : 'h-[144px]'
  }

  const navigate = useNavigate()
  const navigateToSkill = (skillId: string) => {
    navigate(`/explore-learnings/skill/${skillId}`)
  }

  return (
    <div
      className={`gradient-border ${type === 'BIG' ? bigCardClasses.outerCard : smallCardClasses.outerCard} rounded-2xl hover:[box-shadow:0px_14px_24px_0px_#0000000F] transition-all cursor-pointer`}
      onClick={() => navigateToSkill(id)}
    >
      <div
        className={`flex flex-col h-full ${type === 'BIG' ? bigCardClasses.innerCard : smallCardClasses.innerCard} mt-0 bg-white rounded-2xl`}
      >
        <p className={`${type === 'BIG' ? bigCardClasses.nameText : smallCardClasses.nameText}  mb-2`}>{name}</p>
        {description && (
          <p className={`px-4 pb-4 mb-4 body-s overflow-hidden line-clamp-6 ${getDescriptionHeight()}`}>
            {description}
          </p>
        )}
        <div
          className={`bg-[#F4F2EF] rounded-[16px] flex justify-center items-center ${type === 'BIG' ? bigCardClasses.imageContainer : smallCardClasses.imageContainer}`}
        >
          <img
            src={image}
            alt={name}
            loading="eager"
            className={`${type === 'BIG' ? bigCardClasses.imageSize : smallCardClasses.imageSize}`}
          />
        </div>
      </div>
    </div>
  )
}
